import styled from "styled-components";

export const Wrap = styled.div`
    background: linear-gradient(81.56deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.72) 99.99%, rgba(0, 0, 0, 0.52) 100%);
    box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.25);
`;

export const Content = styled.div`
    position: relative;
    padding: 2rem 0;

    .slick-slide {
        div {
            margin: 0 auto;
        }
    }

    .title {
        p {
            width: 100%;
            color: #fff;
            font-size: 2.8rem;
            line-height: 4rem;
            padding-bottom: 2rem;

            strong {
                color: #fe8418;
            }

            &:after {
                content: "";
                width: 28%;
                height: 2px;
                background: #fff;
                display: block;
                position: absolute;
                top: 24%;
                right: 1%;
            }
        }

        @media screen and (max-width: 1024px) {
            p {
                font-size: 2.4rem;
                &:after {
                    top: 35%;
                    right: 2%;
                }
            }
        }

        @media screen and (max-width: 768px) {
            p {
                font-size: 1.8rem;
                line-height: 2rem;

                &:after {
                    width: 25%;
                    top: 22%;
                    right: 2%;
                }
            }
        }

        @media screen and (max-width: 414px) {
            p {
                font-size: 2rem;
                line-height: 2rem;

                &:after {
                    width: 25%;
                    top: 32%;
                    right: 9%;
                }
            }
        }

        @media screen and (max-width: 375px) {
            p {
                font-size: 1.8rem;
                &:after {
                    width: 28%;
                    right: 6%;
                    top: 35%;
                }
            }
        }

        @media screen and (max-width: 320px) {
            p {
                text-align: center;
                &:after {
                    content: none;
                }
            }
        }
    }
`;
